/**
 * Updates the page URL based on the provided current path and new page number.
 *
 * @param {string} currentPath - The current URL path.
 * @param {number} newPage - The new page number to set in the URL.
 * @param {string} [env] - Optional environment variable (e.g., 'development').
 *
 * This function modifies the URL by replacing the last part of the path with the new page number.
 * If the last part of the path is already a number, it is replaced by the new page number.
 *
 * In a development environment, the function logs the updated path.
 * In other environments, the function updates the browser history state with the new path.
 */
export const updatePageUrl = (
  currentPath: string,
  newPage: number,
  env?: string
) => {
  let newPath = getPageUrl(currentPath, newPage);

  // Must start with "/" to avoid being treated as a relative URL by replaceState
  if (!newPath.startsWith('/')) {
    newPath = '/' + newPath;
  }

  if (env === 'development') {
    console.log('Update path: ' + newPath);
  } else {
    history.replaceState(null, '', newPath);
  }
};

export const getPageUrl = (currentPath: string, newPage: number) => {
  const parts = currentPath.split('/').filter((each) => each);
  const lastPart = parts[parts.length - 1];

  // If the url already has a page number, then we want to remove that part from the parts array
  // Use Number instead of parseInt() because parseInt('2025-asdfasdf') will return 2025
  if (Number(lastPart) > 0) {
    parts.splice(parts.length - 1, 1);
  }

  return parts.join('/') + '/' + newPage;
};
